module.exports = __webpack_public_path__ + "static/img/08.b2a7ea3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/daytours/tour3/08.jpg
// module id = qeeO
// module chunks = 0